import {
  GET_HORSE_RACING_CONTINUED_COUPONS_REQUEST,
  GET_HORSE_RACING_CONTINUED_COUPONS_SUCCESS,
  GET_HORSE_RACING_CONTINUED_COUPONS_FAILURE,
  GET_HORSE_RACING_WON_COUPONS_REQUEST,
  GET_HORSE_RACING_WON_COUPONS_SUCCESS,
  GET_HORSE_RACING_WON_COUPONS_FAILURE,
  GET_HORSE_RACING_LOST_COUPONS_REQUEST,
  GET_HORSE_RACING_LOST_COUPONS_SUCCESS,
  GET_HORSE_RACING_LOST_COUPONS_FAILURE,
  GET_HORSE_RACING_SAVED_COUPONS_REQUEST,
  GET_HORSE_RACING_COUPON_RENAME_REQUEST,
  GET_HORSE_RACING_COUPON_RENAME_SUCCESS,
  GET_HORSE_RACING_COUPON_RENAME_FAILURE,
  GET_HORSE_RACING_COUPON_DELETE_REQUEST,
  GET_HORSE_RACING_COUPON_DELETE_SUCCESS,
  GET_HORSE_RACING_COUPON_DELETE_FAILURE,
  GET_HORSE_RACING_SAVED_COUPONS_SUCCESS,
  GET_HORSE_RACING_SAVED_COUPONS_FAILURE,
  SET_HORSE_RACING_COUPONS_ACTIVE_FILTERS,
  RESET_HORSE_RACING_COUPONS_PAGINATION,
  SET_HORSE_RACING_SCROLL_POSITION,
  SET_COUPONS_FILTERS,
  CLEAR_COUPON_STATE,
  GET_HORSE_RACING_SYSTEM_DETAIL_REQUEST,
  GET_HORSE_RACING_SYSTEM_DETAIL_SUCCESS,
  GET_HORSE_RACING_SYSTEM_DETAIL_FAILURE
} from 'Store/constants';


const initialState = {
  continuedCoupons: {
    coupons: [],
    totalElements: 0,
    totalPages: 0
  },
  wonCoupons: {
    coupons: [],
    totalElements: 0,
    totalPages: 0
  },
  lostCoupons: {
    coupons: [],
    totalElements: 0,
    totalPages: 0
  },
  savedCoupons: {
    coupons: [],
    totalElements: 0,
    totalPages: 0
  },
  activeFilters: { filterName: 'CONTINUED', activeTab: 1, programType: 1 },
  pagination: {
    pageIndex: 0,
    pageSize: 10
  },
  systemDetail: {},
  scrollPosition: 0,
  isLoading: null,
  error: null
};

export default (state = initialState, action) => {
  switch (action.type) {
    case GET_HORSE_RACING_CONTINUED_COUPONS_REQUEST:
      return { ...state, isLoading: true, error: null };
    case GET_HORSE_RACING_CONTINUED_COUPONS_SUCCESS:
      return {
        ...state,
        continuedCoupons: {
          totalElements: action.payload.totalElements,
          totalPages: action.payload.totalPages,
          coupons: [...state.continuedCoupons.coupons, ...action.payload.coupons],
        },
        pagination: { ...action.pagination }, isLoading: false, error: null,
      };
    case GET_HORSE_RACING_CONTINUED_COUPONS_FAILURE:
      return { ...state, isLoading: false, error: action.payload };

    case GET_HORSE_RACING_WON_COUPONS_REQUEST:
      return { ...state, isLoading: true, error: null };
    case GET_HORSE_RACING_WON_COUPONS_SUCCESS:
      return {
        ...state,
        wonCoupons: {
          totalElements: action.payload.totalElements,
          totalPages: action.payload.totalPages,
          coupons: [...state.wonCoupons.coupons, ...action.payload.coupons],
        },
        pagination: { ...action.pagination }, isLoading: false, error: null };
    case GET_HORSE_RACING_WON_COUPONS_FAILURE:
      return { ...state, isLoading: false, error: action.payload };

    case GET_HORSE_RACING_LOST_COUPONS_REQUEST:
      return { ...state, isLoading: true, error: null };
    case GET_HORSE_RACING_LOST_COUPONS_SUCCESS:
      return {
        ...state,
        lostCoupons: {
          totalElements: action.payload.totalElements,
          totalPages: action.payload.totalPages,
          coupons: [...state.lostCoupons.coupons, ...action.payload.coupons],
        },
        pagination: { ...action.pagination }, isLoading: false, error: null };
    case GET_HORSE_RACING_LOST_COUPONS_FAILURE:
      return { ...state, isLoading: false, error: action.payload };
    case GET_HORSE_RACING_SAVED_COUPONS_REQUEST:
      return { ...state, isLoading: true, error: null };
    case GET_HORSE_RACING_SAVED_COUPONS_SUCCESS:
      return {
        ...state,
        savedCoupons: {
          totalElements: action.payload.totalElements,
          totalPages: action.payload.totalPages,
          coupons: [...state.savedCoupons.coupons, ...action.payload.coupons],
        },
        pagination: { ...action.pagination }, isLoading: false, error: null };
    case GET_HORSE_RACING_SAVED_COUPONS_FAILURE:
      return { ...state, isLoading: false, error: action.payload };
    case GET_HORSE_RACING_COUPON_DELETE_REQUEST:
      return { ...state, isLoading: true, error: null };
    case GET_HORSE_RACING_COUPON_DELETE_SUCCESS:
      return { ...state, isLoading: false, error: null };
    case GET_HORSE_RACING_COUPON_DELETE_FAILURE:
      return { ...state, isLoading: false, error: action.payload };
    case GET_HORSE_RACING_COUPON_RENAME_REQUEST:
      return { ...state, isLoading: true, error: null };
    case GET_HORSE_RACING_COUPON_RENAME_SUCCESS:
      return { ...state, isLoading: false, error: null };
    case GET_HORSE_RACING_COUPON_RENAME_FAILURE:
      return { ...state, isLoading: false, error: action.payload };
    case SET_HORSE_RACING_COUPONS_ACTIVE_FILTERS:
      return { ...state, activeFilters: action.payload, isLoading: false, error: null };
    case SET_HORSE_RACING_SCROLL_POSITION:
      return { ...state, scrollPosition: action.payload };
    case RESET_HORSE_RACING_COUPONS_PAGINATION:
      return { ...initialState, activeFilters: state.activeFilters };
    case SET_COUPONS_FILTERS:
      return { ...initialState, activeFilters: action.payload };
    case GET_HORSE_RACING_SYSTEM_DETAIL_REQUEST:
      return { ...state, isLoading: true, error: null };
    case GET_HORSE_RACING_SYSTEM_DETAIL_SUCCESS:
      return { ...state, isLoading: false, error: null, systemDetail: action.payload };
    case GET_HORSE_RACING_SYSTEM_DETAIL_FAILURE:
      return { ...state, isLoading: false, error: action.payload };
    case CLEAR_COUPON_STATE:
      return initialState;
    default:
      return state;
  }
};
